import { render, staticRenderFns } from "./OrderNav.vue?vue&type=template&id=7b3662ce&scoped=true&"
import script from "./OrderNav.vue?vue&type=script&lang=js&"
export * from "./OrderNav.vue?vue&type=script&lang=js&"
import style0 from "./OrderNav.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./OrderNav.vue?vue&type=style&index=1&id=7b3662ce&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7b3662ce",
  null
  
)

export default component.exports